import React from 'react'
import PropTypes from 'prop-types'
import ButtonLinkCtaList from '../link/buttonLinkCtaList.jsx'
import { HippostdHtml } from '../blog/blogArticle/componentTypes/HippostdHtml.jsx'
import { CardUtils, EYEBROW_COLOR } from '../cards/card.util.js'
import './splitPanel.css'

const SplitPanel = ({ panels = [] }) => {
  if (!panels.length) return null

  const [leftPanel, rightPanel] = panels

  const renderPanel = (panel, side) => {
    if (!panel) return null

    const bgClass = CardUtils.getBackground(panel.bgColor)
    const isDark = CardUtils.getIsDarkTheme(panel.bgColor)
    const bgImage = panel.bgImage || ''
    const bgImageOverlay = panel.bgImageOverlay || false
    const headingClass = isDark ? 'u-textColorWhite' : 'u-textColorBrandDark'
    const bodyClass = isDark ? 'u-textColorWhite' : 'u-textColorSlateDark'
    const buttonAlignment = panel.buttonAlignment || 'u-flexJustifyStart'
    const hasTitle = Boolean(panel.title?.trim())
    const eyebrow = panel.eyebrow || ''
    const eyebrowLblColor = panel.eyebrowColor
      ? EYEBROW_COLOR?.[panel.eyebrowColor?.trim() || '']
      : ''
    const featureImage = panel.image?.src

    const imageVerticalPadding =
      (panel.bgColor && panel.bgColor !== 'Default') || bgImage
        ? 'u-marginVert12gu'
        : ''

    return (
      <div
        key={side}
        className={`SplitPanel-panel ${side} u-flex u-flexCol ${side === 'left' ? 'u-flexAlignItemsEnd' : 'u-flexAlignItemsStart'} u-flexJustifyCenter ${bgClass} ${panel.panelClassName || ''} ${bgImage ? 'panel-bg-img' : ''} ${bgImage && bgImageOverlay ? 'panel-bg-overlay' : ''}`}
        style={
          bgImage
            ? {
                backgroundImage: `url(${bgImage})`,
              }
            : {}
        }
      >
        {featureImage ? (
          <img
            title={panel.image.title}
            alt={panel.image.alt || 'Banner Image'}
            className={`SplitPanel-image u-sm-marginVert0 ${imageVerticalPadding} u-sizeFull`}
            src={featureImage}
          />
        ) : (
          <div
            className={`SplitPanel-content u-paddingVert8gu u-marginVert8gu ${panel.innerClassName || ''}`}
          >
            {eyebrow && (
              <div
                className={`eyebrow u-textPrimary u-textBold u-marginBottom1gu u-inlineBlock ${eyebrowLblColor || headingClass}`}
              >
                {eyebrow}
              </div>
            )}
            {hasTitle && (
              <h2
                className={`SplitPanel-title u-marginBottom3gu  u-textNoTransform ${headingClass}`}
                title={panel.title}
                aria-label={panel.title}
              >
                {panel.title}
              </h2>
            )}

            {panel.body && (
              <HippostdHtml
                value={panel.body}
                classNames={`SplitPanel-body ${panel.buttons?.length > 0 ? 'u-marginBottom4gu' : ''} ${bodyClass}`}
              />
            )}

            {panel.buttons?.length > 0 && (
              <ButtonLinkCtaList
                linkList={panel.buttons}
                ctaWrapperClassNames={buttonAlignment}
              />
            )}
          </div>
        )}
      </div>
    )
  }

  return (
    <section
      className="SplitPanel u-flex u-sm-flexCol"
      aria-label="Split Panel Content"
    >
      {renderPanel(leftPanel, 'left')}
      {renderPanel(rightPanel, 'right')}
    </section>
  )
}

SplitPanel.propTypes = {
  panels: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      body: PropTypes.string,
      bgColor: PropTypes.string,
      buttons: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
          target: PropTypes.string,
          type: PropTypes.string,
          reversed: PropTypes.bool,
        })
      ),
      buttonAlignment: PropTypes.string,
      panelClassName: PropTypes.string,
      innerClassName: PropTypes.string,
    })
  ).isRequired,
}

export default SplitPanel
